module.exports = require("@swa-ui/core/src/Drawer/Drawer.module.scss");